import { graphClient } from '../graph-client'
import {
  CREATE_ROCKET_GAME_LIVE,
  GET_ROCKET_GAME_LIVE,
  GET_ROCKET_GAME_LIVE_FIRST,
  GET_ROCKETS_GAMES_LIVES,
  UPDATE_ROCKET_GAME_LIVE,
} from './gql'

import type { Create, Get, GetFirst, GetList, Update } from './types'

class RocketGameLiveService {
  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_ROCKET_GAME_LIVE,
      params,
    )
    return request?.createRocketGameLive
  }

  async update(params: Update.Input) {
    const request = await graphClient.request<Update.Output>(
      UPDATE_ROCKET_GAME_LIVE,
      params,
    )
    return request?.updateRocketGameLive
  }

  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_ROCKET_GAME_LIVE,
      params,
    )
    return request?.getRocketGameLive
  }

  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_ROCKET_GAME_LIVE_FIRST,
      params,
    )
    return request?.getRocketGameLiveFirst
  }

  async getList(params: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_ROCKETS_GAMES_LIVES,
      { ...params, skip: (params.take ?? 20) * (params.skip ?? 0) },
    )
    return request?.getRocketsGamesLives
  }
}
export const rocketGameLiveService = new RocketGameLiveService()
